// removed by extract-text-webpack-plugin
module.exports = {"confirm":"Confirm-cssmodule-confirm-FbkMi","title":"Confirm-cssmodule-title-35Vpd","contentView":"Confirm-cssmodule-contentView-26Y8y","content":"Confirm-cssmodule-content-NqT8W","media":"Confirm-cssmodule-media-1Nsz1","button":"Confirm-cssmodule-button-31i1a","cancelButton":"Confirm-cssmodule-cancelButton-2bdHa"};


//////////////////
// WEBPACK FOOTER
// ./themes/BlueTheme/Confirm.cssmodule.less
// module id = 670
// module chunks = 0